<app-kontable
      id="dt_brand"
      title="{{ 'promotion.sectionTitle' | translate }}"
      *ngIf="!show"
      [columns]="[
        'code',
        'description',
        {field: 'flg_coupon_scope', title: 'promotion.flgCouponScope', bodyTemplate: scopeTemplate, filterType: selectFilter, filterOptions: {values: touchPointCouponScopes}},
        {field: 'flg_coupon_action', title: 'promotion.action', bodyTemplate: actionTypeTemplate, filterType: selectFilter, filterOptions: {values: touchPointActionTypes}},
        {field: 'flg_deployable', title: 'promotion.distributed', bodyTemplate: flgDeployableTemplate, filterType: selectFilter, filterOptions: {values: touchPointDeployable}},
        {field: 'flg_offline', title: 'Offline', bodyTemplate: flgOfflineTemplate, filterType: selectFilter, filterOptions: {values: touchPointOffline}}
      ]"
      [titles]="[
        'promotion.code',
        'promotion.description'
      ]"
      [source]="touchPoint"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)">
      <!-- Template Scope -->
      <ng-template #scopeTemplate let-row>
        <ng-container *ngFor="let scope of touchPointCouponScopes">
          <span *ngIf="row.flg_coupon_scope === scope.value">{{ scope.label }}</span>
        </ng-container>
      </ng-template>
      <!-- Template Action Type -->
      <ng-template #actionTypeTemplate let-row>
        <ng-container *ngFor="let at of touchPointActionTypes">
          <span *ngIf="row.flg_coupon_action === at.value">{{ at.label }}</span>
        </ng-container>
      </ng-template>
      <!-- Template Flag Deployable -->
      <ng-template #flgDeployableTemplate let-row>
        <ng-container *ngFor="let dep of touchPointDeployable">
          <span *ngIf="row.flg_deployable === dep.value">{{ dep.label }}</span>
        </ng-container>
      </ng-template>
      <!-- Template Flag Offline -->
      <ng-template #flgOfflineTemplate let-row>
        <span *ngIf="row.flg_offline === '1'">{{ 'common.yes' | translate }}</span>
        <span *ngIf="row.flg_offline === '0'">NO</span>
      </ng-template>
    </app-kontable>
    <kv-promo-touch-point-detail
      *ngIf="show"
      [titlePage]="titlePage"
      [touchPoint]="addEditTouchPoint"
      (hide)="toggleShow()"
      (saveTouchPoint)="saveTouchPoint($event)"
      [ochannel_type_pid]="ochannel_type_pid"
      [touchPointPrivateActions]="touchPointPrivateActions"
      [flgCouponScopes]="touchPointCouponScopes"
      [flgCouponActions]="touchPointActionTypes"
      [deployableOptions]="touchPointDeployable"
      [actions]="touchPointPrivateActions">
    </kv-promo-touch-point-detail>


// WEBPACK FOOTER //
// ./src/app/views/promotion/touch-point/touch-point.component.html